import ConditionalRender from "app/common/components/ConditionalRender";
import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const AuthLayout = ({children}) => {

    const {pathname} = useLocation();

    // Clear redirect and transactions tracking
    useEffect(_ => {
        sessionStorage.removeItem("redirectToHome");
        localStorage.removeItem(`test-refs`);
        localStorage.removeItem(`live-refs`);
        localStorage.removeItem(`test-transactions`);
        localStorage.removeItem(`live-transactions`);
    }, []);
    
    return  <div className="auth relative">
                <div className="flex w-full relative">
                    <div className="w-full lg:w-1/2 2xl:w-2/5 px-8 sm:px-10 flex flex-col">
                        <div className={`flex sticky top-0 z-60 justify-between py-6 bg-white text-grey-6`}>
                            <Link
                                to={"/"}
                            >
                                <img src="/assets/media/logos/logo.png" className="w-24" alt="V" />
                            </Link>
                            <ConditionalRender
                                render={["/login", "/register"]}
                            >
                                <div className="my-auto">
                                    <span className="hidden sm:inline-block">
                                        { pathname === "/register" ? "Already have an account? " : "Don't have an account yet?" } 
                                    </span>
                                    <Link
                                        to={pathname === "/register" ? "/login" : "/register"}
                                        className="btn-outline rounded-3xl ml-4 text-primary border-primary font-bold"
                                    >
                                        Sign { pathname === "/register" ? "in" : "up"}
                                    </Link>
                                </div>
                            </ConditionalRender>
                        </div>
                        <div className="w-full md:w-8/12 lg:w-9/12 2xl:w-8/12 mx-auto py-20 ">
                            {children}
                        </div>
                        <div className={`flex py-3 bg-white justify-between  pb-7 mt-auto sticky bottom-0 text-xs text-grey-7`}>
                    
                            <div>
                                <a
                                    className="underline"
                                    href="https://myvendy.com/terms-and-conditions"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Terms 
                                </a>
                                <span> & </span>
                                <a
                                    className="underline"
                                    href="https://myvendy.com/privacy-policy"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Privacy 
                                </a>
                            </div>
                            <div>
                                <span
                                    className="pr-9 drop-down-icon cursor-pointer -mr-4"
                                >
                                    Eng
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="hidden lg:flex lg:w-1/2 2xl:w-3/5 border-r bg-gradient-to-t from-grad-1 to-grad-2">
                        {/* <img src="/assets/media/image/auth-img.png" className="max-w-[75%] my-auto mx-auto" alt="Student" /> */}
                    </div>
                </div>
            </div>
}

export default AuthLayout;